import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeHouseholdSetupFeatureChildInfoModule } from '../lib/se-household-setup-feature-child-info.module'
import { ChildInfoDocsComponent } from './child-info-docs/child-info-docs.component'
import { PROVIDERS } from './providers'

@NgModule({
  declarations: [
    ChildInfoDocsComponent,
  ],
  exports: [
    ChildInfoDocsComponent,
  ],
  imports: [
    CommonModule,
    SeFeCardModule,
    SeHouseholdSetupFeatureChildInfoModule
  ],
  providers: PROVIDERS
})
export class SeHouseholdSetupFeatureChildInfoDocsModule { }
